<script setup lang="ts">
import { UpdateProfilePasswordDocument } from '~/apollo/gql/graphql'
import type { FormError } from '#ui/types'

type PasswordChangeData = {
  current_password: string
  password: string
  confirm_password: string
}

const emit = defineEmits(['success'])

const form = ref(null)
const loading = ref(false)
const success = ref(false)
const errors = ref<FormError[]>([])
const fields = [
  {
    name: 'current_password',
    label: 'Password Lama',
    type: 'password',
    required: true,
    placeholder: 'Masukkan password lama Anda'
  },
  {
    name: 'password',
    label: 'Password Baru',
    type: 'password',
    required: true,
    placeholder: 'Masukkan password baru Anda'
  },
  {
    name: 'confirm_password',
    label: 'Konfirmasi Password Baru',
    type: 'password',
    required: true,
    placeholder: 'Konfirmasi password baru Anda'
  }
]

const { mutate: performUpdatePassword } = useMutation(UpdateProfilePasswordDocument)
const { validatePassword } = useFormValidation()

const validate = (state: PasswordChangeData) => {
  errors.value = []

  if (!state.current_password) {
    errors.value.push({ path: 'current_password', message: 'Password lama wajib diisi' })
  }

  validatePassword(state, errors)

  return errors.value
}

const onSubmit = async ({ current_password, password }: PasswordChangeData) => {
  loading.value = true

  try {
    await performUpdatePassword({ old_password: current_password, new_password: password })

    success.value = true
    emit('success')
    form.value.formRef.clear()
  } catch (err) {
    console.error(err)
    errors.value.push({ path: 'confirm_password', message: 'Password lama Anda salah' })
  } finally {
    loading.value = false
  }
}
</script>

<template>
  <UAuthForm
    ref="form"
    class="mx-auto my-8"
    :fields="fields"
    :validate="validate"
    :loading="loading"
    title="Ubah Password"
    align="top"
    icon="i-heroicons-key"
    :submit-button="{ label: 'Ubah Password', color: 'primary' }"
    @submit="onSubmit"
  >
    <template #description> Isi form di bawah untuk mengubah password Anda. </template>

    <template
      v-if="errors.length"
      #validation
    >
      <UAlert
        color="red"
        icon="i-heroicons-information-circle-20-solid"
        title="Gagal mengubah password"
      />
    </template>
  </UAuthForm>
</template>
